import { Callout, Text, Box } from "@radix-ui/themes";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { ErrorData, ServiceError } from "@/shared/api/lod-api";

interface PredictionErrorProps {
  error: ErrorData | null | undefined;
}

export const ErrorMessage = ({ error }: PredictionErrorProps) => {
  if (!error) return null;

  const errorData = error?.data as ServiceError;

  if (!errorData) return null;

  const errorType = errorData?.type || "Unknown";
  const errorMessage = errorData?.errors?.[0]?.msg || "An error occurred";

  return (
    <Box p="4">
      <Callout.Root color="red" size="1" className="mb-2">
        <Callout.Icon>
          <ExclamationTriangleIcon />
        </Callout.Icon>
        <Callout.Text>
          <Text size="2">Failed to load predicted cart.</Text>
          <br />
          <Text size="2">Please try again</Text>
          <br />
          <br />
          <Text size="2">Error Type: {errorType}</Text>
          <br />
          <Text size="2">{errorMessage}</Text>
        </Callout.Text>
      </Callout.Root>
    </Box>
  );
};
